import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const ShoppingPlusSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m1 18l.5-2H7l-.5 2zm2-4l.5-2H10l-.5 2zm15.575 6l.5-4l.725-6l.25-1.975zM6 22q-.825 0-1.412-.587T4 20h14.575L20.05 8.025H17.3l-.275 2.125q-.05.425-.375.663T15.9 11t-.662-.363t-.188-.737l.225-1.875H11.3l-.275 2.1q-.05.425-.375.675t-.75.2t-.675-.375t-.2-.75l.225-1.85H5.5q.1-.85.65-1.437T7.5 6h2q.2-1.875 1.288-2.937T13.75 2q1.6 0 2.663 1.188T17.45 6H20q.9.025 1.5.7t.475 1.575l-1.5 12q-.1.75-.663 1.238T18.5 22zm5.5-16h3.975q.025-.825-.562-1.412T13.5 4q-.875 0-1.388.538T11.5 6"
    ></path>
  </svg>
);
export const ShoppingPlusIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ShoppingPlusSvg} {...props} />
);
